// extracted by mini-css-extract-plugin
module.exports = {"header":"CampaignHeader_header__KGrm5","logo":"CampaignHeader_logo__ITMpG"};